module.exports = __webpack_public_path__ + "img/MonetPainting1.18690a64.jpg";